<template>
  <div class="outer-hg-100">
    <div class="info-content" ref="scrollContent">
      <div class="make-title">Make Your Test</div>
      <div class="test-name-row">
        <div class="test-name-col">
          <div class="test-name test-name-1">Test Name</div>
          <div class="mock-test-text">{{ stepOneData.testName }}</div>
        </div>
        <div class="test-name-col">
          <div class="test-name test-name-1">Target Exam</div>
          <div class="mock-test-text">
            {{ stepOneData.targetSelected.text }}
          </div>
        </div>
      </div>
      <div class="test-name">Subjects</div>
      <div class="card-panel">
        <div class="jee-user-row-cust">
          <div
            class="card-data"
            :style="item.checked ? { border: '1px solid #089BE5' } : ''"
            v-for="(item, index) in items"
            :key="index"
          >
            <img
              :src="
                require('@/assets/img/myttargetexamicon/' + item.text + '.svg')
              "
              class="card-icon"
            />
            <div class="card-title" :class="item.text.toLowerCase()">
              {{ item.text }}
            </div>
            <v-checkbox
              v-model="item.checked"
              color="secondary-darken-3"
              @change="getSelectedSubject(item)"
            ></v-checkbox>
          </div>
        </div>
      </div>
      <div class="myt-dropdown add-ch-arrow practice-session-drop-outer">
        <div class="test-name test-top-20">Difficulty</div>
        <div
          class="practice-session-drop-down"
          v-if="selectedSubjectWithDifficultyLevel"
        >
          <div
            class="field-data"
            v-for="(item, index) in selectedSubjectWithDifficultyLevel"
            :key="index"
          >
            <label>{{ item.text }}</label>
            <v-select
              v-model="item.difficulty"
              :items="difficultyLevels"
              item-text="title"
              item-value="id"
              hide-details
              dense
              outlined
              class="required fix-140-width"
              :class="item.difficulty ? 'selected-border-myt' : ''"
            >
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-btn">
      <div></div>
      <v-btn
        color="primary"
        class="cust-btn myt-next"
        @click="
          onNextClick({
            stepOneData: stepOneData,
            stepTwoData: {...stepTwoData, selectedSubjects, selectedSubjectWithDifficultyLevel},
            stepThreeData: { selectedSubjects }
          })
        "
      >
        Next
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import constants from "../../../../utils/constants";

export default {
  props: ["onNextClick", "stepOneData", "stepTwoData"],
  name: "StepThreeData",
  data() {
    return {
      e1: 1,
      selectedDifficulty: [],
      items: [],
      difficultyLevels: constants.DIFFICULTY_LEVELS,
      selectedSubjectWithDifficultyLevel: [],
      selectedSubjects: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.scrollContent.scrollTop = this.$refs.scrollContent.scrollHeight;
      if(window.innerWidth < 991){
        let scrollElem = document.getElementsByClassName("test-top-20");
        document.body.scrollTop = document.documentElement.scrollTop = scrollElem[0].offsetTop + 50;
      }else{
        document.body.scrollTop = document.documentElement.scrollTop = document.body.scrollHeight;
      }
    });
    if (this.stepTwoData) {
      if (this.stepTwoData.subjects) {
        this.items = this.stepTwoData.subjects;
      }
      if (this.stepTwoData.selectedSubjectWithDifficultyLevel) {
        this.selectedSubjectWithDifficultyLevel = this.stepTwoData.selectedSubjectWithDifficultyLevel;
      }
      if (this.stepTwoData.selectedSubjects) {
        this.selectedSubjects = this.stepTwoData.selectedSubjects;
      }
    }
    if (this.data) {
      this.selectedSubjects = _.cloneDeep(this.data.selectedSubjects);
      let difficultyCheck = [];
      this.selectedSubjects = this.selectedSubjects.map((s) => {
        difficultyCheck.push(s);
        delete s.difficulty;
        delete s.sortBy;
        return s;
      });
      this.selectedSubjectWithDifficultyLevel = this.data.selectedSubjects;
    }
  },
  methods: {
    ...mapActions({
      getTestTarget: "utilStore/getTestTarget",
      getDataTreeWithLevelPublic: "utilStore/getDataTreeWithLevelPublic"
    }),
    getSelectedSubject(item) {
      if (item.checked) {
        this.selectedSubjects.push(item);
      } else {
        let index =
          this.selectedSubjects &&
          this.selectedSubjects.length &&
          this.selectedSubjects.findIndex((x) => x.value.id === item.value.id);
        this.selectedSubjects &&
          this.selectedSubjects.length &&
          this.selectedSubjects.splice(index, 1);
      }
      this.onSelectSubject();
    },
    getSubjects() {
      // this.selectedSubjectWithDifficultyLevel = [];
      let reqData = {
        level: 2,
        parent: 3
      };
      this.subjects = [];
      this.selectedSubjects = [];
      this.$root.showLoader = true;
      this.getDataTreeWithLevelPublic(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          response.map((x) => {
            let c = {};
            if (x.id === constants.BIOLOGY_SUBJECT_ID) {
              constants.BIOLOGY_SUBSUBJECTS.map((s) => {
                let sub = {};

                sub.text = s.title;
                sub.value = { ...s };
                sub.checked = false;
                this.subjects.push(sub);
              });
            } else {
              c.text = x.title;
              c.value = { ...x };
              c.checked = false;
              this.subjects.push(c);
            }
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onSelectSubject() {
      if (this.selectedSubjects && this.selectedSubjects.length > 0) {
        this.selectedSubjectWithDifficultyLevel = this.selectedSubjectWithDifficultyLevel.filter(
          (item) => {
            return !!this.selectedSubjects.find((s) => {
              return s.value.id == item.value.id;
            });
          }
        );
        this.selectedSubjects.map((item) => {
          const e = this.selectedSubjectWithDifficultyLevel.find((s) => {
            return s.value.id == item.value.id;
          });
          if (!e) {
            this.selectedSubjectWithDifficultyLevel.push(item);
          }
        });
      } else {
        this.selectedSubjectWithDifficultyLevel = [];
      }
    }
  },
  watch: {
    stepOneData(val) {
    },
    stepTwoData(val) {
      if (val) {
        if (val.subjects) {
          this.items = val.subjects;
        }
        if (val.selectedSubjectWithDifficultyLevel) {
          this.selectedSubjectWithDifficultyLevel =
            val.selectedSubjectWithDifficultyLevel;
        }
        if (val.selectedSubjects) {
          this.selectedSubjects = val.selectedSubjects;
        }
      }
    }
  }
};
</script>
